import { Workbook } from "../services/excelEvents";
import { ClassificationRuleMap } from "../services/workbookClassification";

export const classificationRules: ClassificationRuleMap = {
    "BS_DEMO_1": {
        name: "Has DemoSheet_BS Worksheet",
        description: "Identifies book as being applicable for the demo",
        looseCriteria: (workbook:Workbook) => {
            return !!workbook.worksheets.find(ws => ws.name.includes("DemoSheet_BS"));
        },
        tightCriteria: () => {
            return true;
        }
    },
    "BS_DEMO_LOOSE_ONLY": {
        name: "Has DemoSheet_BS Worksheet",
        description: "Loose matches with a workbook that contains a 'DemoSheet_BS' worksheet",
        looseCriteria: (workbook:Workbook) => {
            return !!workbook.worksheets.find(ws => ws.name.includes("DemoSheet_BS"));
        },
        tightCriteria: () => {
            return false;
        }
    },
    "BS_DEMO_CONFLICT": {
        name: "Has DemoSheet_BS2 Worksheet",
        description: "Loose matches with a workbook that contains a 'DemoSheet_BS' worksheet",
        looseCriteria: (workbook:Workbook) => {
            return !!workbook.worksheets.find(ws => ws.name.includes("DemoSheet_BS2"));
        },
        tightCriteria: () => {
            return true;
        }
    },
    "ReviewToolingTest": {
        name: "Review Tooling Test",
        description: "Identifies book as being applicable for the review tooling test",
        looseCriteria: (workbook:Workbook) => {
            return workbook.name.includes("Review Tooling");
        },
        tightCriteria: (workbook:Workbook) => {
            return !!workbook.worksheets.find(ws => ws.name.includes("M25 Rental Property"));
        }
    }
}